import { initReactI18next } from "react-i18next"
import i18n from "i18next"
import german from "@/assets/locales/de.json" assert { type: "json" }
import english from "@/assets/locales/en.json" assert { type: "json" }
import french from "@/assets/locales/fr.json" assert { type: "json" }
import italian from "@/assets/locales/it.json" assert { type: "json" }
import { getPersistedLanguage } from "@/lib/language-storage"
import { UI_DISPLAY_LANGUAGES, UiDisplayLanguage } from "@/types/UiDisplayLanguage"

type Resources = {
  [key in UiDisplayLanguage]: { translation: typeof english }
}

const RESOURCES: Resources = {
  en: {
    translation: english,
  },
  de: {
    translation: german,
  },
  fr: {
    translation: french,
  },
  it: {
    translation: italian,
  },
}

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: RESOURCES,
    lng: getPersistedLanguage(),
    fallbackLng: UI_DISPLAY_LANGUAGES.ENGLISH,
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  })
export default i18n
